<template>
  <div>
    <div class="bto-sb-widget">
      <div class="bto-sb-widget-title bto-sb-title-icon bto-sb-title-big">
        <span class="bto-app-icon bto-app-history"></span>
        <h3>{{ t("Mobile.PendingNegotiations") }}</h3>
      </div>
    </div>
    <div class="bto-sb-widget-wrap bto-sb-negotiation-wrap">
      <!------------------------------------- Widget Widget Negotiation ---------------------------------------->
      <div class="bto-sb-widget bto-sb-history-top-message">{{ t("W.N.O") }}</div>
      <empty-state
        v-if="bets.length === 0"
        :message="emptyStateStatusMessage"
        :icon-class="emptyStateClass" />
      <div class="bto-sb-widget bto-sb-history bto-sb-negotiation">
        <div class="bto-sb-history-items" v-for="(bet, i) in bets" :key="i" @click="loadDetails(i)">
          <MyBetsInlineHeader
            :type="'negotiation'"
            :timer="genereteTimeText(getCounter(bet.betSlipGroupID))"
            :bet="bet"
            :isOpened="isOpened(i)" />
          <MyBetsInlineDetails :betDetails="bet" :isNegotiation="true" :isOpened="isOpened(i)" />
        </div>
      </div>
    </div>
    <!------------------------------------- END Widget Widget Negotiation ---------------------------------------->
  </div>
</template>
<script>
  import { genereteTimeText } from '@/services/utils';
  import MybetsModel from '@/models/mybets/agent-mobile/mybet-model';
  import store from '../../../store/index';
  import MyBetsInlineHeader from './mybet-header/my-bets-inline-header';
  import MyBetsInlineDetails from './mybet-details/my-bets-inline-details';
  import { EmptyState, ICON_CLASS } from '../empty-state';

  export default {
    name: 'NegotiationComponentInline',
    components: {
      MyBetsInlineHeader,
      MyBetsInlineDetails,
      EmptyState,
    },
    data() {
      return {
        negotiationCounters: {},
        openedDetails: [],
        bets: [],
        emptyStateIcon: ICON_CLASS.MYBETS,
        loadingSpinner: ICON_CLASS.LOADING,
        isLoading: true,
      };
    },
    watch: {
      // TODO: Refactor this
      '$store.state.NegotiationsModule.negotiations.Data': function () {
        this.getNegotiations();
        this.isLoading = false;
      },
      '$store.state.NegotiationsModule.negotiationCounters': function () {
        this.getNegotiationCounters();
      },
    },
    created() {
      store.commit('hideAfterRouteWidgets');
      this.getNegotiations();
    },
    mounted() {
      this.getNegotiationCounters();
    },
    computed: {
      emptyStateClass() {
        return this.isLoading ? this.loadingSpinner : this.emptyStateIcon;
      },
      emptyStateStatusMessage() {
        return this.isLoading ? this.t('Mobile.LoadingMore') : this.t('M.MyBetsEmpty');
      },
    },
    methods: {
      getNegotiations() {
        const negotiations = store.state.NegotiationsModule.negotiations.Data || [];
        this.bets = negotiations.map(n => new MybetsModel(n));
      },
      getNegotiationCounters() {
        this.negotiationCounters = store.state.NegotiationsModule.negotiationCounters;
      },
      loadDetails(idx) {
        if (this.openedDetails.includes(idx)) {
          const index = this.openedDetails.indexOf(idx);
          if (index > -1) {
            this.openedDetails.splice(index, 1);
          }
        } else {
          this.openedDetails.push(idx);
        }
      },
      isOpened(idx) {
        const index = this.openedDetails.indexOf(idx);
        if (index > -1) {
          return true;
        } else {
          return false;
        }
      },
      getCounter(id) {
        if (this.negotiationCounters.hasOwnProperty(id)) {
          return this.negotiationCounters[id].total || '';
        }
      },
      genereteTimeText,
    }
  };
</script>
